import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { PageHeader } from '../components/PageHeader';
import { TeamMemberCard } from '../components/TeamMemberCard';
import { TrainingClinic } from '../components/TrainingClinic';
import { CtaBand } from '../components/CtaBand';
import { images } from '../data/clinic';
import { team } from '../data/team';
export function About() {
  const specialists = team[0].members;
  return <>
      <PageHeader title="Over ons" crumbs={[{
      label: 'Over ons'
    }]} intro="Excellent Care Clinics is een onafhankelijk specialistisch pijnbehandelcentrum waar patiënten met pijn middels hoogwaardige zorg worden behandeld. De behandelingen worden uitgevoerd door anesthesioloog-pijnspecialisten en (pijn)verpleegkundigen. Wij zijn gevestigd in Velsen-Noord." data-id="element-382" data-mp="37740ejji6khs" />

      <section className="mx-auto max-w-7xl px-5 py-16 lg:px-8 lg:py-20" data-id="element-383" data-mp="1lu1bexl2oz87">
        <div className="grid gap-4 sm:grid-cols-[1.4fr_1fr]" data-id="element-384" data-mp="1lry9pgak5hnn">
          <img src={images.reception} alt="Ontvangstbalie van Excellent Care Clinics" className="aspect-[16/10] w-full rounded-3xl object-cover" data-id="element-385" data-mp="1uitg17pzjftl" />
          <img src={images.procedure} alt="Behandelkamer van Excellent Care Clinics" className="aspect-[16/10] w-full rounded-3xl object-cover sm:aspect-auto sm:h-full" data-id="element-386" data-mp="1pl1rmnojubu5" />
        </div>

        <div className="mt-16 grid gap-8 lg:grid-cols-12 lg:gap-16" data-id="element-387" data-mp="1ylhr7m268ytq">
          <h2 className="font-display text-3xl font-semibold tracking-tight text-ink sm:text-4xl lg:col-span-5" data-id="element-388" data-mp="2dfcveerdtzyl">
            Kwaliteit en veiligheid gaan hand in hand
          </h2>
          <p className="text-lg leading-relaxed text-muted lg:col-span-7" data-id="element-389" data-mp="2m97qetysia0i">
            Wij streven naar een hoge kwaliteit, zodat de hoge verwachtingen van de patiënt worden overtroffen. Met veilig werken
            wordt de kans op complicaties zoveel mogelijk beperkt. Deze combinatie van goede kwaliteit en veiligheid levert een
            prettige werksfeer op en doet patiënten graag terugkomen.
          </p>
        </div>
      </section>

      <section className="border-t border-line" data-id="element-390" data-mp="1osjrinf68n6b">
        <div className="mx-auto max-w-7xl px-5 py-16 lg:px-8 lg:py-20" data-id="element-391" data-mp="1svgfyure7di6">
          <div className="flex flex-col justify-between gap-6 sm:flex-row sm:items-end" data-id="element-392" data-mp="1xvb6uyb64338">
            <h2 className="font-display text-3xl font-semibold tracking-tight text-ink sm:text-4xl" data-id="element-393" data-mp="1xthwb7xfoypy">Onze pijnspecialisten</h2>
            <Link to="/team" className="inline-flex items-center gap-2 whitespace-nowrap text-[15px] font-semibold text-primary hover:text-primary-dark" data-id="element-394" data-mp="27lnpgkzf9m6q">
              Bekijk het hele team
              <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-395" data-mp="2gm2cbos1b9cc" />
            </Link>
          </div>
          <ul className="mt-10 grid grid-cols-2 gap-x-5 gap-y-10 sm:grid-cols-3 lg:grid-cols-4" data-id="element-396" data-mp="2llf9b2cmdwsn">
            {specialists.slice(0, 4).map(m => <li key={m.name} data-id="element-397" data-mp="m9m80tisu5a4">
                <TeamMemberCard member={m} data-id="element-398" data-mp="r6w7l1zwjxbo" />
              </li>)}
          </ul>
        </div>
      </section>

      <TrainingClinic data-id="element-399" data-mp="jnvcn5363bzx" />
      <CtaBand data-id="element-400" data-mp="jo528rkavh53" />
    </>;
}